import React, { useEffect } from "react";
import PropTypes from "prop-types";

import { useAccessTypeStore, WithAccessTypeProvider } from "./components/hooks";
import HubFeed from "./components/HubFeed";
import WorkspaceContainer from "./Container";
import { HubContextProvider } from "./Provider";

export function Workspace({ hub, advisor }) {
  const { ready, setAccessStatus } = useAccessTypeStore();

  useEffect(() => {
    setAccessStatus(advisor?.role?.title === "Administrator");
  }, [advisor, setAccessStatus]);

  if (!ready) return null;

  return (
    <HubContextProvider
      hubId={hub.id}
      hubShortId={hub.hubId}
      hubClientPoolId={hub.clientPool.id}
      sortByLastName={hub.sortByLastName}
      hubAdvisor={advisor}
      advisors={hub.advisors}
      integration={advisor.integrations.find((i) => {
        return i.hubId === hub.id;
      })}
    >
      <HubFeed />
      <WorkspaceContainer />
    </HubContextProvider>
  );
}

Workspace.propTypes = {
  hub: PropTypes.object.isRequired,
  advisor: PropTypes.object.isRequired,
};

Workspace.defaultProps = {};

export default WithAccessTypeProvider(Workspace);
